(() => {
  const { COLORS } = CONSTANTS;
  const { chartCustomLabels, callApi } = Shared;

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    layout: { padding: { left: 35, right: 35, bottom: 40 } },
    scales: { x: { grid: { color: "rgba(0,0,0,0)" }, ticks: { display: false } }, y: { ticks: {} } },
    interaction: { mode: "index" },
    animations: { tension: { duration: 1000, easing: "linear", from: 1, to: 0 } },
    plugins: { legend: { display: false }, tooltip: { usePointStyle: true } },
  };

  const buildChart = (chartContainerId) => {
    const student_id = $("#" + chartContainerId).data("id");
    const form = document.getElementById("fitness_marks_scores_form");
    const formData = new FormData(form);
    const current_year = formData.get("fitness_mark_scores[current_year]") || "";
    const teacher_id = formData.get("fitness_mark_scores[teacher_id]") || "";
    const physical_exercise_id = $(`#category_${student_id}`).val();

    const url = new URL("/api/fitness_marks", window.location.href);
    url.searchParams.set("student_id", student_id);
    url.searchParams.set("current_year", current_year);
    url.searchParams.set("teacher_id", teacher_id);
    url.searchParams.set("physical_exercise_id", physical_exercise_id);
    url.searchParams.set("include", "student_year");
    url.searchParams.set("sort", "examined_at");
    url.searchParams.set("direction", "asc");
    for (let i = 1; i <= Number(current_year); i++) url.searchParams.append("year_group[]", i);

    return callApi({ url: url.href }).then((json) => {
      const dataFormatter = new Jsona();
      const data = dataFormatter.deserialize(json);

      const labels = data.map((d) => ordinal(d["student-year"]["academical-year"]) + " year -" + d["examined-at"]);
      const dataSet = data.map((d) => +d.value);
      const decoratedValues = data.map((d) => d["decorated-value"]);

      // Check if any decorated_value is different from value
      const shouldHideYAxis = decoratedValues.some((decorated, index) => +decorated !== dataSet[index]);

      const graphContainer = document.querySelector(`#${chartContainerId}`);
      graphContainer.querySelector("canvas").remove();
      graphContainer.appendChild(document.createElement("canvas"));

      const measureIntervalEle = document.querySelector(
        `#category_${student_id} option[value='${physical_exercise_id}']`
      );

      if (measureIntervalEle) {
        chartOptions.scales.y.ticks.stepSize = +measureIntervalEle.dataset.measureInterval;
      }

      new Chart(graphContainer.querySelector("canvas"), {
        type: "line",
        data: {
          labels,
          datasets: [
            {
              data: dataSet,
              borderColor: COLORS.primary,
              fill: false,
              backgroundColor: "white",
              borderWidth: 1,
              pointBorderColor: COLORS.primary,
              pointRadius: 4,
            },
          ],
        },
        options: {
          ...chartOptions,
          scales: {
            ...chartOptions.scales,
            y: shouldHideYAxis ? { ticks: { display: false } } : chartOptions.scales.y,
          },
          plugins: {
            ...chartOptions.plugins,
            tooltip: {
              callbacks: {
                label: function (context) {
                  const index = context.dataIndex;
                  return `Score: ${decoratedValues[index]}`;
                },
              },
            },
          },
        },
        plugins: [chartCustomLabels],
      });
    });
  };

  window.buildFitnessMarkScoreChart = buildChart;
})();
